import { useState, useCallback } from "react";

export function useTradeGuard() {
  const [needsBuilderApproval, setNeedsBuilderApproval] = useState(false);

  const checkBeforeTrade = useCallback(async (portfolio) => {
    const approved = portfolio?.builder_fee_approved === true;
    if (!approved) setNeedsBuilderApproval(true);
    return approved;
  }, []);

  return { needsBuilderApproval, setNeedsBuilderApproval, checkBeforeTrade };
}
